import { render, staticRenderFns } from "./imprimir-pauta.vue?vue&type=template&id=71c03234&"
import script from "./imprimir-pauta.vue?vue&type=script&lang=js&"
export * from "./imprimir-pauta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports